function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M406 223.672c1.444 0 5.708-4.589 6.798-5.426 6.771-5.196 13.833-10.06 21.059-14.673 21.208-13.535 43.889-24.304 67.93-32.456 39.779-13.489 84.633-12.944 123.858 2.064 16.184 6.19 30.041 16.189 46.255 22.245 18.238 6.815 37.708 10.174 57.142 12.066 53.188 5.179 96.005-30.908 136.822-57.62 45.081-29.5 93.001-49.564 148.866-46.975 78.11 3.618 151.18 53.658 184.27 120.775H406z",
  fill: "url(#pathstream-user3_svg__2vz5rx0s3b)",
  opacity: 0.5
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M960.042 194.69l5.539 59.31h-50.106l-2.865-42.985c-13.13-2.345-32.627-4.99-45.757-7.334-2.332-.416-4.762-.874-6.649-2.318-1.888-1.445-3.026-4.198-1.899-6.303.944-1.768 3.06-2.484 4.996-2.941 6.018-1.42 12.585-1.896 18.761-1.3.255.023.51.051.763.079-.143-.043-.287-.083-.431-.126a368622.1 368622.1 0 01-31.314-9.047c-2.387-.689-4.858-1.423-6.736-3.064-1.161-1.016-2.068-2.425-2.145-3.975-.058-3.54 2.293-5.36 6.528-5.829-2.713-.957-5.365-1.404-7.605-3.392-.008-.006-.016-.015-.022-.021a4.91 4.91 0 01-1.246-5.545c1.385-3.265 4.833-4.254 10.333-2.978-1.31-.609-2.303-1.873-2.59-3.301a4.767 4.767 0 011.105-4.061c1.043-1.162 2.616-1.719 4.164-1.838 1.548-.118 3.095.161 4.622.437.962.174 1.588.482 2.55.657.071-.248.127-.501.179-.752.386-1.867 2.24-3.669 4.102-3.97 1.727-.28 3.49.113 5.199.504l6.285 1.437c2.947.672 5.893 1.346 8.839 2.019l8.337 1.904c2.989.681 5.98 1.365 8.968 2.05 2.834.646 5.665 1.293 8.499 1.941l.156.035c3.028.692 6.075 1.315 9.117 1.933.006.002.013.002.019.003 2.944.599 5.883 1.194 8.802 1.847 6.625 1.482 9.439 1.87 15.661 4.656 13.853 6.201 14.272 17.387 15.841 32.268z",
  fill: "#FFB9B9"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M860.04 148.817l38.284 11.271m-48.137-3.167l45.437 12.535m-46.896-.597l42.752 10.711m-9.707 11.289a84.575 84.575 0 0015.412-3.53c4.853-1.601 9.572-3.647 14.524-4.897 9.619-2.429 19.988-1.724 29.198 1.984m-28.299 26.599l10.329 2.381",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M996.405 194.69L990.866 254h50.104l2.87-42.985c13.13-2.345 32.62-4.99 45.75-7.334 2.34-.416 4.77-.874 6.65-2.318 1.89-1.445 3.03-4.198 1.9-6.303-.94-1.768-3.06-2.484-4.99-2.941-6.02-1.42-12.59-1.896-18.76-1.3-.26.023-.51.051-.77.079.15-.043.29-.083.43-.126l31.32-9.047c2.38-.689 4.85-1.423 6.73-3.064 1.16-1.016 2.07-2.425 2.15-3.975.06-3.54-2.3-5.36-6.53-5.829 2.71-.957 5.36-1.404 7.6-3.392l.03-.021a4.917 4.917 0 001.24-5.545c-1.38-3.265-4.83-4.254-10.33-2.978 1.31-.609 2.3-1.873 2.59-3.301a4.764 4.764 0 00-1.11-4.061c-1.04-1.162-2.61-1.719-4.16-1.838-1.55-.118-3.09.161-4.62.437-.96.174-1.59.482-2.55.657a9.895 9.895 0 01-.18-.752c-.39-1.867-2.24-3.669-4.1-3.97-1.73-.28-3.49.113-5.2.504-2.1.478-4.19.958-6.29 1.437l-8.84 2.019c-2.77.635-5.56 1.269-8.33 1.904-2.99.681-5.98 1.365-8.97 2.05-2.83.646-5.67 1.293-8.5 1.941-.05.011-.1.024-.16.035-3.02.692-6.07 1.315-9.11 1.933l-.02.003c-2.95.599-5.88 1.194-8.8 1.847-6.63 1.482-9.44 1.87-15.66 4.656-13.857 6.201-14.276 17.387-15.845 32.268z",
  fill: "#FFB9B9"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1096.41 148.817l-38.29 11.271m48.14-3.167l-45.44 12.535m46.9-.597l-42.75 10.711m9.71 11.289a84.544 84.544 0 01-15.42-3.53c-4.85-1.601-9.57-3.647-14.52-4.897-9.62-2.429-19.99-1.724-29.2 1.984m28.3 26.599l-10.33 2.381",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1047 7.053v104.894c0 1.686-1.5 3.053-3.34 3.053H901.338c-1.844 0-3.338-1.367-3.338-3.053V7.053C898 5.367 899.494 4 901.338 4h142.322c1.84 0 3.34 1.367 3.34 3.053z",
  fill: "url(#pathstream-user3_svg__txibksqtjd)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1047 7.01V14H898V7.01c0-1.663 1.495-3.01 3.338-3.01h142.322c1.84 0 3.34 1.349 3.34 3.01z",
  fill: "#416A86"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1042.03 8.806a1.33 1.33 0 00-1.09-1.532c-.72-.118-1.4.376-1.52 1.104-.11.728.38 1.415 1.1 1.533.72.118 1.4-.377 1.51-1.105zm-12.18.089a1.333 1.333 0 00-.98-1.607c-.71-.17-1.42.276-1.59.994-.17.717.27 1.437.98 1.606.71.17 1.43-.275 1.59-.993zm5.73.641a1.34 1.34 0 000-1.89 1.313 1.313 0 00-1.87 0 1.357 1.357 0 000 1.89c.52.521 1.36.521 1.87 0z",
  fill: "#EBF3F8"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M927.169 46h81.661c3.96 0 7.17-2.727 7.17-6.09V28.09c0-3.363-3.21-6.09-7.17-6.09h-81.661C923.21 22 920 24.727 920 28.09v11.82c0 3.363 3.21 6.09 7.169 6.09z",
  fill: "#D0E4ED"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1000.91 36.785c.33-2.139-1.117-4.139-3.225-4.467-2.108-.328-4.079 1.14-4.403 3.28-.324 2.138 1.122 4.138 3.23 4.466 2.107.328 4.078-1.14 4.398-3.279zM936.917 40h46.166c2.163 0 3.917-1.792 3.917-4s-1.754-4-3.917-4h-46.166c-2.163 0-3.917 1.792-3.917 4s1.754 4 3.917 4z",
  fill: "#7198B2"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M927.169 77h81.661c3.96 0 7.17-2.727 7.17-6.09V59.09c0-3.363-3.21-6.09-7.17-6.09h-81.661C923.21 53 920 55.727 920 59.09v11.82c0 3.363 3.21 6.09 7.169 6.09z",
  fill: "#D0E4ED"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M997.3 69.61c2.122-.213 3.67-2.131 3.46-4.285-.21-2.154-2.101-3.727-4.222-3.513-2.122.213-3.672 2.132-3.461 4.285.21 2.154 2.101 3.727 4.223 3.514zM936.917 69h46.166c2.163 0 3.917-1.792 3.917-4s-1.754-4-3.917-4h-46.166c-2.163 0-3.917 1.792-3.917 4s1.754 4 3.917 4z",
  fill: "#fff"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M927.169 108h81.661c3.96 0 7.17-2.727 7.17-6.09V90.09c0-3.363-3.21-6.09-7.17-6.09h-81.661C923.21 84 920 86.727 920 90.09v11.82c0 3.363 3.21 6.09 7.169 6.09z",
  fill: "#D0E4ED"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M997 101a4 4 0 100-8 4 4 0 000 8zm-60.083 0h46.166c2.163 0 3.917-1.792 3.917-4s-1.754-4-3.917-4h-46.166c-2.163 0-3.917 1.792-3.917 4s1.754 4 3.917 4z",
  fill: "#fff"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1145.47 58.002h-105.98a2.499 2.499 0 00-2.49 2.514v86.321c0 1.388 1.11 2.514 2.49 2.514h105.98c1.38 0 2.49-1.126 2.49-2.514V60.516a2.499 2.499 0 00-2.49-2.514z",
  fill: "url(#pathstream-user3_svg__xbwckloyie)"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1037 60.514v5.832h110.96v-5.832a2.499 2.499 0 00-2.49-2.513h-105.98a2.499 2.499 0 00-2.49 2.513z",
  fill: "#7198B2"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1132.09 62.9a1.1 1.1 0 001.1-1.104 1.1 1.1 0 00-1.1-1.104c-.6 0-1.09.494-1.09 1.104 0 .61.49 1.104 1.09 1.104zm10.04 0c.6 0 1.09-.494 1.09-1.104 0-.61-.49-1.104-1.09-1.104a1.1 1.1 0 00-1.1 1.104 1.1 1.1 0 001.1 1.104zm-5.02 0c.6 0 1.09-.494 1.09-1.104 0-.61-.49-1.104-1.09-1.104-.61 0-1.09.494-1.09 1.104 0 .61.48 1.104 1.09 1.104z",
  fill: "#EBF3F8"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1106.75 122.355c8.19-8.273 8.19-21.686 0-29.959a20.801 20.801 0 00-29.64 0c-8.19 8.273-8.19 21.686 0 29.959a20.801 20.801 0 0029.64 0z",
  fill: "#7198B2"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1101.14 102.331l-3.77 2.47v-1.184c0-.959-.77-1.737-1.72-1.737h-12.21c-.95 0-1.72.778-1.72 1.737v7.52c0 .959.77 1.737 1.72 1.737h12.21c.95 0 1.72-.778 1.72-1.737v-1.197l3.74 2.758a.648.648 0 001.03-.529v-9.286c0-.519-.57-.83-1-.55v-.002z",
  fill: "#fff"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1145.47 58.002h-105.98a2.499 2.499 0 00-2.49 2.514v86.321c0 1.388 1.11 2.514 2.49 2.514h105.98c1.38 0 2.49-1.126 2.49-2.514V60.516a2.499 2.499 0 00-2.49-2.514z",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1097.05 24.572a5.588 5.588 0 013.47 3.822l4.22-10.896 10.88 4.029a5.611 5.611 0 01-.52-5.116c1.14-2.943 4.45-4.445 7.4-3.353a5.592 5.592 0 013.26 7.304 5.79 5.79 0 01-3.86 3.494l10.88 4.029-10.86 28.013-10.03-3.714a5.786 5.786 0 003.47-3.37 5.592 5.592 0 00-3.26-7.305c-2.95-1.092-6.26.41-7.4 3.353a5.594 5.594 0 00.31 4.773l-11.13-4.123 4.22-10.896a5.766 5.766 0 01-5.19.615 5.592 5.592 0 01-3.26-7.305c1.14-2.943 4.45-4.444 7.4-3.352v-.002z",
  fill: "#fff"
});

var _ref22 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#pathstream-user3_svg__a)"
}, React.createElement("path", {
  d: "M1097.05 24.572a5.588 5.588 0 013.47 3.822l4.22-10.896 10.88 4.029a5.611 5.611 0 01-.52-5.116c1.14-2.943 4.45-4.445 7.4-3.353a5.592 5.592 0 013.26 7.304 5.79 5.79 0 01-3.86 3.494l10.88 4.029-10.86 28.013-10.03-3.714a5.786 5.786 0 003.47-3.37 5.592 5.592 0 00-3.26-7.305c-2.95-1.092-6.26.41-7.4 3.353a5.594 5.594 0 00.31 4.773l-11.13-4.123 4.22-10.896a5.766 5.766 0 01-5.19.615 5.592 5.592 0 01-3.26-7.305c1.14-2.943 4.45-4.444 7.4-3.352v-.002z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M1123.15 8.33l18.89 37.654-38.19 19.286-18.89-37.653 38.19-19.286z",
  fill: "url(#pathstream-user3_svg__78uiq3tdfg)"
}));

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M842.63 23.267l-15.984 4.326c-9.457 2.56-15.028 12.384-12.441 21.943 2.587 9.558 12.352 15.232 21.811 12.672l14.8-4.006 5.205 8.498.785-10.928c6.428-4.064 9.746-12.035 7.635-19.833-2.587-9.558-12.351-15.233-21.811-12.672z",
  fill: "url(#pathstream-user3_svg__ry6byjxqwh)"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M923 82.678v57.644c0 .927-1.385 1.678-3.092 1.678H788.092c-1.709 0-3.092-.751-3.092-1.678V82.678c0-.927 1.383-1.678 3.092-1.678h131.816c1.707 0 3.092.751 3.092 1.678z",
  fill: "url(#pathstream-user3_svg__z7p2ftoxwi)"
});

var _ref25 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 898,
  cy: 114,
  r: 15,
  fill: "#fff"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M868 108h-73v5h73v-5zm0 9h-73v4h73v-4zm0 8h-73v5h73v-5zm0-25h-73v5h73v-5z",
  fill: "#fff"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M860 108h-65v5h65v-5z",
  fill: "#416A86"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M825 117h-30v4h30v-4zm8 8h-38v5h38v-5zm17-25h-55v5h55v-5z",
  fill: "#7198B2"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M913.999 108.258C912.372 101.244 906.268 96.021 899 96l.06 16s12.448-3.148 14.939-3.742zM923 83.408V89H785v-5.592c0-1.33 1.385-2.408 3.092-2.408h131.815c1.706 0 3.091 1.079 3.091 2.408H923z",
  fill: "#416A86"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M918.833 85.032a1.118 1.118 0 00-.916-1.285 1.111 1.111 0 00-1.273.926 1.12 1.12 0 00.917 1.286 1.11 1.11 0 001.272-.927zm-10.217.075a1.12 1.12 0 00-.824-1.348 1.109 1.109 0 00-1.334.833 1.12 1.12 0 00.824 1.348 1.108 1.108 0 001.334-.833zm4.806.537a1.13 1.13 0 000-1.585 1.1 1.1 0 00-1.568 0 1.13 1.13 0 000 1.585 1.1 1.1 0 001.568 0z",
  fill: "#D0E4ED"
});

var _ref31 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "pathstream-user3_svg__2vz5rx0s3b",
  x1: 802.5,
  y1: 96.132,
  x2: 802.5,
  y2: 281.147,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.401,
  stopColor: "#A4D8F8"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "pathstream-user3_svg__txibksqtjd",
  x1: 972.5,
  y1: 4,
  x2: 972.5,
  y2: 145,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#7198B2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#D0E4ED"
})), React.createElement("linearGradient", {
  id: "pathstream-user3_svg__xbwckloyie",
  x1: 1092.48,
  y1: 58.002,
  x2: 1092.48,
  y2: 149.351,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#D0E4ED"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#EBF3F8",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "pathstream-user3_svg__78uiq3tdfg",
  x1: 1122.96,
  y1: 55.623,
  x2: 1103.97,
  y2: 18.019,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.02,
  stopColor: "#7198B2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#416A86"
})), React.createElement("linearGradient", {
  id: "pathstream-user3_svg__ry6byjxqwh",
  x1: 834.638,
  y1: 25.43,
  x2: 846.506,
  y2: 69.275,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#7198B2"
}), React.createElement("stop", {
  offset: 0.685,
  stopColor: "#416A86"
})), React.createElement("linearGradient", {
  id: "pathstream-user3_svg__z7p2ftoxwi",
  x1: 854,
  y1: 81,
  x2: 854,
  y2: 142,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#D0E4ED"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#7198B2"
})), React.createElement("clipPath", {
  id: "pathstream-user3_svg__gywel35sra"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(398)",
  d: "M0 0h801v224H0z"
})), React.createElement("clipPath", {
  id: "pathstream-user3_svg__0de5golvjc"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(760 1)",
  d: "M0 0h419v230H0z"
})));

var SvgPathstreamUser3 = function SvgPathstreamUser3(props) {
  return React.createElement("svg", _extends({
    width: 1200,
    height: 224,
    viewBox: "0 0 1200 224",
    fill: "none"
  }, props), React.createElement("g", {
    clipPath: "url(#pathstream-user3_svg__gywel35sra)"
  }, _ref, React.createElement("g", {
    clipPath: "url(#pathstream-user3_svg__0de5golvjc)"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, React.createElement("mask", {
    id: "pathstream-user3_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1089,
    y: 12,
    width: 44,
    height: 44
  }, _ref21), _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30)), _ref31);
};

export default __webpack_public_path__ + "708e91f1cc0f83a15ee349bafc865c3c.svg";
export { SvgPathstreamUser3 as ReactComponent };